import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import styles from './styles/ShoppingWithSocial.scss';
import FacebookIcon from 'dibs-icons/exports/Facebook';
import TwitterIcon from 'dibs-icons/exports/Twitter';
import PinterestIcon from 'dibs-icons/exports/Pinterest';
import { injectIntl, defineMessages } from 'react-intl';
import { shareViaFacebook, shareViaPinterest, shareViaTwitter } from '../utils/shareHelpers';

const messages = defineMessages({
    shareText: {
        id: 'ShoppingWithSocial.pinterest',
        defaultMessage: 'Shopping with {name} | 1stDibs.com',
    },
});

function getShareOptions({ shoppingWith, intl }) {
    const url = document.location.toString();

    return {
        url,
        text: intl.formatMessage(messages.shareText, {
            name: shoppingWith.title,
        }),
    };
}

function ShoppingWithSocialComponent({ shoppingWith, intl }) {
    return (
        <React.Fragment>
            <a
                href="#"
                className={`${styles.iconWrapper} ${styles.pinterest}`}
                onClick={e => {
                    e.preventDefault();
                    const { url, text } = getShareOptions({ shoppingWith, intl });

                    shareViaPinterest({
                        description: `${text} ${url}`,
                        url,
                        media: shoppingWith.mainImage,
                    });
                }}
            >
                <PinterestIcon className={styles.icon} />
            </a>
            <a
                href="#"
                className={`${styles.iconWrapper} ${styles.facebook}`}
                onClick={e => {
                    e.preventDefault();
                    shareViaFacebook();
                }}
            >
                <FacebookIcon className={styles.icon} />
            </a>
            <a
                href="#"
                className={`${styles.iconWrapper} ${styles.twitter}`}
                onClick={e => {
                    e.preventDefault();
                    shareViaTwitter(getShareOptions({ shoppingWith, intl }));
                }}
            >
                <TwitterIcon className={styles.icon} />
            </a>
        </React.Fragment>
    );
}

ShoppingWithSocialComponent.propTypes = {
    shoppingWith: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
};

export const ShoppingWithSocial = createFragmentContainer(injectIntl(ShoppingWithSocialComponent), {
    shoppingWith: graphql`
        fragment ShoppingWithSocial_shoppingWith on ShoppingWith {
            mainImage
            title
        }
    `,
});
